export const USER_FETCH = 'USER_FETCH';
export const USER_IDENTIFY = 'USER_IDENTIFY';
export const USER_UNIT = 'USER_UNIT';
export const USER_STAFF = 'USER_STAFF';
export const USER_FEATURES = 'USER_FEATURES';
export const USER_CODE = 'USER_CODE';
export const SIGN_OUT = 'SIGN_OUT';